import withPagination from '@package/components/Views/withPagination';
/* eslint-disable-next-line import/no-unresolved */
import SummaryViewOrig from '@plone/volto-original/components/theme/View/SummaryView';

export default withPagination(SummaryViewOrig);
